import { useSelector } from 'react-redux';
import { useAccountAbstractionStore } from '../store/AccountAbstractionContext';
import { useMemo } from 'react';
import { selectSmartWalletAddress } from '@/services/auth/authSelectors';

export const useWalletAddress = () => {
  const accountAbstractionStore = useAccountAbstractionStore();
  const smartWalletAddress = useSelector(selectSmartWalletAddress);

  const walletAddress = useMemo(() => {
    const smartWallet = accountAbstractionStore?.state?.smartWalletAddress;
    return smartWallet || smartWalletAddress;
  }, [accountAbstractionStore?.state?.smartWalletAddress]);

  return {
    walletAddress,
    isLoading: accountAbstractionStore?.state?.loading,
  };
};
